export type AgencyStatus = 'Active' | 'Transferred' | 'Terminated' | 'Unknown';

export interface IAgencyCodeRow {
  agencyName: string;
  agencyCode: string;
  eCliqCode: string;
  status: AgencyStatus;
  address: string;
  city: string;
  state: string;
  zipCode: string;
}

//Response shape of the Kyber-backed agency details endpoint (MVC Json() serializes C# property names as-is).
export interface IAgencyDetailsResponse {
  AgencyCode: string | null;
  AgencyName: string | null;
  LineOfBusinessStatus: string | null;
  StreetAddressLine1: string | null;
  StreetAddressLine2: string | null;
  City: string | null;
  State: string | null;
  Zip: string | null;
}

const STATUS_SORT_ORDER: Record<AgencyStatus, number> = {
  Active: 0,
  Transferred: 1,
  Terminated: 2,
  Unknown: 3,
};

export function getStatusSortOrder(status: AgencyStatus): number {
  return STATUS_SORT_ORDER[status] ?? STATUS_SORT_ORDER.Unknown;
}


//Maps Kyber's raw lineOfBusinessStatus to a display status.
//Confirmed values from Kyber: APPT, TRAN, TERM.

export function mapAgencyStatus(rawStatus: string | null | undefined): AgencyStatus {
  const normalized = rawStatus?.trim().toUpperCase() ?? '';

  switch (normalized) {
    case 'APPT':
      return 'Active';
    case 'TRAN':
      return 'Transferred';
    case 'TERM':
      return 'Terminated';
    default:
      return 'Unknown';
  }
}
